import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getHoianUser } from 'apis/CommerceGraphql/chatOrder';
import { setHoianUser } from 'store/ducks/chatOrderStore';
import { StoreState } from 'store/ducks';

export const useHoianUser = (id: string | null) => {
  const dispatch = useDispatch();
  const hoianUser = useSelector((state: StoreState) =>
    id ? state.chatOrderStore.hoianUsers[id] : null
  );

  useEffect(() => {
    if (!id || hoianUser) return;

    const fetchUser = async () => {
      const user = await getHoianUser(id);
      if (user) {
        dispatch(setHoianUser({ id, user }));
      }
    };

    fetchUser();
  }, [id, hoianUser, dispatch]);

  return {
    hoianUser,
    nickname: hoianUser?.nickname ?? null,
  };
};
